//
//
//
//
//
//
//
//
//

export default {
  name: 'card-row',

  props: {
    actions: Boolean,

    height: {
      type: String,
      default: 'auto'
    },

    img: String
  },

  computed: {
    classes () {
      return {
        'card__row--actions': this.actions
      }
    },

    styles () {
      const styles = {
        height: this.height
      }

      if (this.img) {
        styles.background = `url(${this.img}) center center / cover no-repeat`
      }

      return styles
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/CardRow.vue